import React, { createContext, useContext, useState } from 'react';
import { formIntialState } from '@/constants/formInitConstants';
import { FormikValues } from 'formik';

interface IFormContext {
  formSnapshot: typeof formIntialState | FormikValues;
  setFormSnapshot: (values: typeof formIntialState | FormikValues) => void;
  activeStep: number;
  prevActiveStep: number;
  setActiveStep: (step: number) => void;
  nextFormStep: (values: FormikValues) => void;
  prevFormStep: (values: FormikValues) => void;
  resetForm: () => void;
}
const MultiStepFormContext = createContext<IFormContext | null>(null);

const MultiStepFromProvider = ({ children }) => {
  const [formSnapshot, setFormSnapshot] = useState<typeof formIntialState | FormikValues>(
    formIntialState
  );
  const [activeStep, setActiveStep] = useState(0);
  const [prevActiveStep, setPrevActiveStep] = useState(-1);

  const setCurrentStep = (newStep: number) => {
    setActiveStep(newStep);
    setPrevActiveStep(activeStep);
  }

  const next = (values: FormikValues) => {
    //always start each step at the top of the page
    window.scrollTo(0, 0);
    if (values) setFormSnapshot(values);
    setCurrentStep(activeStep + 1);
  };

  const prev = (values: FormikValues) => {
    if (values) setFormSnapshot(values);
    setCurrentStep(activeStep - 1);
  };

  const reset = () => {
    setCurrentStep(0);
    setFormSnapshot(formIntialState);
  };

  const value: IFormContext = {
    formSnapshot,
    setFormSnapshot,
    activeStep,
    prevActiveStep,
    setActiveStep: setCurrentStep,
    nextFormStep: next,
    prevFormStep: prev,
    resetForm: reset,
  };

  return <MultiStepFormContext.Provider value={value}>{children}</MultiStepFormContext.Provider>;
};

const useMultiStepFormContext = () => {
  const context = useContext(MultiStepFormContext);
  return context;
};

export { MultiStepFromProvider, useMultiStepFormContext };
